module.exports = __webpack_public_path__ + "static/media/opensans-light.8be511a0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-light.woff2
// module id = 1836
// module chunks = 0